const nf = new Intl.NumberFormat('hu', {})

export function formatNumber(n: number | undefined) {
	return n == null ? '?' : nf.format(n)
}
